import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoHeyGenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoHeyGen",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.27 15.662c5.471-1.906 11.713-4.431 12.926-5.358 1.753-1.34 2.086-2.02 2.208-3.165.19-1.783-2.908-6.379-2.908-6.379-.202-.308-.71-.315-.899-.29C11.67.6 10.36 1.81 9.72 2.492L1.143 12.693c-.748.917-1.584 2.367-.88 2.93.376.225.632.169 1.005.039m11.234-2.307L1.354 17.43c-1.697.61-1.062 3.483.344 4.461l12.138 9.078c1.724 1.404 4.629 1.234 4.629-.89v-12.83c0-2.74-3.409-4.57-5.961-3.894m18.764.004s-4.142-1.156-6.834-1.521c-2.209-.3-4.12 3.078-4.12 4.925l.054 13.247c0 1.477 1.71 1.477 2.497.233 0 0 5.567-8.06 8.542-13.053.596-.978 1.002-3.515-.139-3.83m-.484-1.608c.35.063.59.086.625-.1.104-.916-.63-1.27-1.25-1.752 0 0-9.67-6.777-14.174-9.582-.655-.408-.825-.05-.83-.036-.078.208.052.565.173.853 1.182 2.797 3.609 6.58 6.28 8.08 1.664.935 8.708 2.452 9.176 2.537Z"
    })
  }));
};
LogoHeyGenIcon.displayName = 'LogoHeyGenIcon';